/** 新手引导相关API **/
import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";

// 新手引导用到的接口
export function restAccountUserTaskGradeGetTaskProgress(params) {
  return omniAxios({
    url: config.restAccountUserTaskGradeGetTaskProgressPath,
    method: "get",
    params,
  });
}

export function restAccountUserTaskGradeGetIsEject(params) {
  return omniAxios({
    url: config.restAccountUserTaskGradeGetIsEjectPath,
    method: "get",
    params,
  });
}

export function restAccountUserTaskGradeCoreKeyword(params) {
  return omniAxios({
    url: config.restAccountUserTaskGradeCoreKeywordPath,
    method: "get",
    params,
  });
}

export function restAccountUserTaskGradeGetIndustryInfo(params) {
  return omniAxios({
    url: config.restAccountUserTaskGradeGetIndustryInfoPath,
    method: "get",
    params,
  });
}

export function subscribeRecommendKeyword(params) {
  return omniAxios({
    url: config.restSubscribeRecommendKeywordPath,
    method: "get",
    params,
  });
}

export function restAccountUserTaskGradeGetUserTask(params) {
  return omniAxios({
    url: config.restAccountUserTaskGradeGetUserTaskPath,
    method: "get",
    params,
  });
}

export function restAccountUserTaskGradeGetNextTask(params) {
  return omniAxios({
    url: config.restAccountUserTaskGradeGetNextTaskPath,
    method: "post",
    params,
    isFormData: true,
  });
}

export function restAccountSubscribeEmailPushPeriodAndAcceptMailBox(params) {
  return omniAxios({
    url: config.pushPeriodAndAcceptMailBoxPath,
    params,
    method: "get",
  });
}

export function subscribeGetUserDefaultRegion(params) {
  return omniAxios({
    url: config.restAccountSubscribeGetUserDefaultRegionPath,
    method: "get",
    params,
  });
}

export function websiteSearchSolrCompany(params) {
  return omniAxios({
    url: config.restWebsiteSearchSolrCompanyPath,
    method: "post",
    params,
  });
}

export function companySpaceCheckNewUser() {
  return omniAxios({
    url: config.restCompanySpaceCheckNewUserPath,
    method: "get",
    params: {},
  });
}
